import { Tag } from './tag.component';

export * from './tag.component';
export default Tag;

Tag.define('der-ui-tag');

declare global {
    interface HTMLElementTagNameMap {
        'der-ui-tag': Tag;
    }
}
